<app-menu></app-menu>
<div class="appContentsContainer">
  <form
    [formGroup]="personalParams"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        {{ "personalParams.title" | translate }}
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="usBuzonPreferente" for="usBuzonPreferente"
              >Buz&oacute;n pref.</label
            >
          </div>
        </div>
        <div class="inputContainer">
          <select formControlName="usBuzonPreferente">
            <option
              *ngFor="let typeMailBox of typesMailBoxList"
              value="{{ typeMailBox }}"
            >
              {{ typeMailBox }}
            </option>
          </select>
          <div class="supIndexRequestAux"></div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="usLineas" for="usLineas">N&uacute;m. l&iacute;neas</label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="number" formControlName="usLineas" max="99" />
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow" *appPermsRoles="[roles.CONCES]">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="usPeriodicidad" for="usPeriodicidad"
              >Period. de correos</label
            >
          </div>
        </div>
        <div class="inputContainer">
          <select formControlName="usPeriodicidad">
            <option
              *ngFor="let frecuency of frecuencyList"
              value="{{ frecuency }}"
            >
              {{ frecuency }}
            </option>
          </select>
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </div>

     <div class="row compressedRow" *appPermsRoles="[roles.CONCES]">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="legalClause" for="legalClause">
            
            </label
            >
          </div>
        </div>
    </div>
    
     <div class="row compressedRow" *appPermsRoles="[roles.CONCES]">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="legalClause" for="legalClause">
            A trav&eacute;s de este formulario elige recibir informaci&oacute;n sobre sus solicitudes, as&iacute; como la periodicidad del env&iacute;o de los correos.
            </label
            >
          </div>
        </div>
    </div>
    
     <div class="row compressedRow" *appPermsRoles="[roles.CONCES]">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="legalClause" for="legalClause">
            Si no desea recibir m&aacute;s informaci&oacute;n, puede restablecer estas opciones en cualquier momento.
            </label
            >
          </div>
        </div>
    </div>
    
    <ng-container *appPermsRoles="[roles.RHOMOLOG]" class="w-100">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="usCertificadoPwd" for="usCertificadoPwd"
                >Actualizar certificado</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="checkbox"
              formControlName="editCertificate"
              [checked]="personalParams.value.editCertificate"
              (click)="resetForm()"
            />
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label>Certificado</label>
            </div>
          </div>
          <div class="inputContainer">
            <div class="dummyButtonContainer">
              <div class="dummyButton">
                <em class="fas fa-file-upload"></em>
              </div>
              <div
                class="dummyFileInput"
                [ngClass]="{
                  noEditable: !personalParams.value.editCertificate
                }"
                style="min-height: 20px !important"
              >
                <div
                  class="dummyFileName adjustText"
                  style="max-height: 20px !important"
                >
                  {{ personalParams.value.usCertificado }}
                </div>
              </div>
            </div>
            <input
              class="inputFile detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
              type="file"
              (change)="handleFileInput($event)"
              [disabled]="!personalParams.value.editCertificate"
            />
            <div class="supIndexRequestAux">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="usCertificadoPwd" for="usCertificadoPwd"
                >Contrase&ntilde;a cert.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="password"
              formControlName="usCertificadoPwd"
              class="readOnly"
              [readonly]="!personalParams.value.editCertificate"
            />
            <div class="supIndexRequest">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="usCertificadoPwdConfirm" for="usCertificadoPwdConfirm"
                >Conf. contrase&ntilde;a cert.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="password"
              formControlName="usCertificadoPwdConfirm"
              [readonly]="!personalParams.value.editCertificate"
              class="readOnly"
            />
            <div class="supIndexRequest">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="usCaducidad" for="usCaducidad"
                >Fecha caducidad cert.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="date"
              formControlName="usCaducidad"
              min="{{ today }}"
              class="readOnly"
              [readonly]="!personalParams.value.editCertificate"
            />
            <div class="supIndexRequest">*</div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="consultaEditarButtonGroup">
      <div class="backButton">
        <button
          class="formButton"
          *ngIf="personalParams.pristine"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
        <button
          class="formButton"
          *ngIf="!personalParams.pristine"
          [swal]="confirmSwal"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="middleButtonAceptar">
        <button class="formButton" type="submit">
          {{ "commons.ok" | translate }}
        </button>
      </div>
    </div>
    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goPredefinedMailBox()"
    >
    </swal>

    <swal
      #infoSwal
      html="<strong>  Datos de configuraci&oacute;n personal actualizados. </strong> </br> <strong>Estos cambios solo aplicar&aacute;n al volver a iniciar sesi&oacute;n.</strong>"
      icon="success"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
    >
    </swal>
  </form>
</div>
